import { render, staticRenderFns } from "./logisticsBindingModal.vue?vue&type=template&id=cf61f75c&scoped=true"
import script from "./logisticsBindingModal.vue?vue&type=script&lang=js"
export * from "./logisticsBindingModal.vue?vue&type=script&lang=js"
import style0 from "./logisticsBindingModal.vue?vue&type=style&index=0&id=cf61f75c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf61f75c",
  null
  
)

export default component.exports